import '../styles/style.css';

import * as React from 'react';

import {
    GlancePair,
    Identifier,
    Partner,
    Region,
    StudioAppConfig,
} from 'glance-datatypes';
import { GridList, GridTile } from 'material-ui/GridList';
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';
import { grey500, grey800, red300, red500 } from 'material-ui/styles/colors';
import { stateFilters, typeFilters } from '../Utils';

import Configuration from '../Configuration';
import Dialog from 'material-ui/Dialog';
import DropDownMenu from 'material-ui/DropDownMenu';
import EmptyMessage from './common/EmptyMessage';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import Glance from './Glance';
import Loader from './common/Loader';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import ReactPaginate from 'react-paginate';
import RestService from '../RestService';
import Snackbar from 'material-ui/Snackbar';
import Utils from '../Utils';
import { connect } from 'react-redux';

const removeIcon = <FontIcon className='material-icons'>delete</FontIcon>;
let timer;

const styles = {
    footer: {
        position: 'fixed',
        bottom: '0px',
        paddingBottom: '10px',
        paddingTop: '10px',
        zIndex: 10,
        backgroundColor: grey800,
        width: '90%',
        maxWidth: '1400px',
        display: 'inline-flex',
        justifyContent: 'center',
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    } as React.CSSProperties,
    footerButton: {
        maxWidth: '232px',
        flex: '1 1 0%',
        marginLeft: '10px',
        marginRight: '10px',
    } as React.CSSProperties,
    deleteButton: {
        color: red500,
        background: red300,
    } as React.CSSProperties,
    disabledButton: {
        backgroundColor: grey500,
    } as React.CSSProperties,
    loaderStyle: {
        textAlign: 'center',
    } as React.CSSProperties,
};

enum TypeFilter {
    ALL, WALLPAPER, STORY, SPONSORED,
}

enum StateFilter {
    PENDING, APPROVED, REJECTED, REMOVED,
}

enum Action {
    REMOVE,
}

interface Props {
    params: any;
    history?: any;
    conf?: Configuration;
    studioAppConfig: StudioAppConfig;
}

interface State {
    expiryState?: Map<string, boolean>;
    partnerFilter?: Partner;
    partnerAutoApprove?: boolean;
    regionFilter?: Region;
    regionFilters?: Region[];
    typeFilter: TypeFilter;
    expiryFilter: boolean;
    stateFilter?: StateFilter;
    filteredGlances?: GlancePair[];
    selectedGlances?: Map<string, boolean>;
    loadMessage?: string;
    showLoader?: boolean;
    possibleActions?: Action[];
    actionClicked?: Action;
    openConfirmDialog: boolean;
    openSnackbar: boolean;
    snackbarMessage: string;
    isSponsoredEnabled: boolean;
    glancePairs?: GlancePair[];
    perPage: number;
    totalGlances: number;
    selectedPage: number;
    searchTerm: string;
    showActive: boolean;
}

class ModeratorGlances extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            partnerFilter: null,
            regionFilters: null,
            regionFilter: null,
            typeFilter: TypeFilter.STORY,
            stateFilter: StateFilter.APPROVED,
            expiryFilter: false,
            openConfirmDialog: false,
            openSnackbar: false,
            snackbarMessage: '',
            loadMessage: 'Select a partner and region to load',
            isSponsoredEnabled: false,
            perPage: 12,
            glancePairs: [],
            totalGlances: 0,
            selectedPage: 1,
            searchTerm: '',
            selectedGlances: new Map<string, boolean>(),
            possibleActions: [],
            showActive: false,
        };
    }

    componentWillMount() {
        // TODO: now studioAppConfig will always have a default value. this check needs to be changed

        if (!this.props.studioAppConfig) {
            this.props.history.push('/login');
            window.location.reload();
        }

        if (this.props.params && this.props.params.partnerName) {
            const partnerName = this.props.params.partnerName;
            const region = this.props.params.region;

            this.props.studioAppConfig.partners.forEach((partner) => {
                if (partner.name == partnerName) {
                    if (region) {
                        this.setPartnerAndRegion(partner, parseInt(region));
                    } else {
                        this.setPartner(partner);
                    }
                }
            });
        }

    }

    componentDidMount() {
        this.updateActions(this.state.stateFilter);
    }

    pushFilterUrl = (partnerFilter: Partner, regionFilter: Region) => {

        this.props.history.push('/' + this.props.params.role + '/published'
            + (partnerFilter ? ('/' + partnerFilter.partnerId + '/' + encodeURIComponent(partnerFilter.name)
                + (regionFilter ? ('/' + regionFilter + '/' + Utils.getReadableRegionName(regionFilter)) : ''))
                : ''
            ),
        );
    }

    setPartner = (partner: Partner) => {
            const { partnerAutoApprove, isSponsoredEnabled, regionFilters }= this.getPartnerDetails(partner);
            const regionFilter = regionFilters.length === 1 ? regionFilters[0] : null;
            const partnerFilter = partner;
            const loadMessage = regionFilter === null ? 'Select a Region' : '';

                this.setState({
                    ...this.state,
                    partnerFilter,
                    regionFilters,
                    regionFilter,
                    partnerAutoApprove,
                    isSponsoredEnabled,
                    loadMessage,
                }, () => {
                    if (regionFilters.length === 1) {
                        this.pushFilterUrl(partner, regionFilter);
                        this.fetchGlances(true);
                    }
                });
    }

    setPartnerAndRegion = (partner: Partner, region: Region) => {

        const { regionFilters, partnerAutoApprove, isSponsoredEnabled } = this.getPartnerDetails(partner);

            this.setState({
                ...this.state,
                partnerFilter: partner,
                regionFilter: region,
                regionFilters,
                partnerAutoApprove,
                isSponsoredEnabled,
                loadMessage: 'Loading live glances for ' + partner.name + ' in ' + Utils.getReadableRegionName(region) + ' ...',
                showLoader: true,
            }, () => {
                this.fetchGlances(true);
            });
    }

    fetchGlances = (resetPage) => {
        const { regionFilter, partnerFilter, perPage, selectedPage, expiryFilter, stateFilter, typeFilter, searchTerm, totalGlances } = this.state;
        const type = typeFilters[typeFilter];
        const state = stateFilters[stateFilter];

        const offset = resetPage ? 0 : (selectedPage - 1) * perPage;

        const payload = {
            limit: perPage,
            offset,
            expired: expiryFilter,
            state,
            type,
            region: regionFilter,
            partner: partnerFilter,
            search: searchTerm,
        };
        this.setState({
            ...this.state,
            showLoader: true,
            selectedPage: resetPage ? 1 : selectedPage,
            totalGlances: resetPage ? 0 : totalGlances,
            /* setting totalGlances 0 & forcing react-paginate to rerender because of
            https://github.com/AdeleD/react-paginate/issues/124 */
        },() => {

        RestService.getGlances(payload).then((response: any) => {
            this.setState({
                ...this.state,
                glancePairs: response.pairs,
                showLoader: false,
                snackbarMessage: 'Glances loaded',
                openSnackbar: true,
                loadMessage: null,
                totalGlances: response.count,
            });
        }).catch(error => {
            this.setState({
                ...this.state,
                snackbarMessage: 'Loading failed. Try refresh or Contant Glance Support.',
                openSnackbar: true,
                loadMessage: 'Loading failed. Try refresh or Contant Glance Support.',
                showLoader: false,
            });
        });
        });


    }

    getPartnerDetails = (partner: Partner) => {
        let isSponsoredEnabled = false;
        let partnerAutoApprove = false;
        let regionFilters = [];
        if (partner) {
            const partnerObj = this.props.studioAppConfig.partnerMetas.find(partnerMeta => partnerMeta.partnerId === partner.partnerId);
            if (partnerObj) {
                partnerAutoApprove = partnerObj.autoApprove;
                isSponsoredEnabled = partnerObj.isSponsoredEnabled ? partnerObj.isSponsoredEnabled : false;
                regionFilters = partnerObj.supportedRegions;
            }
        }

        return { partnerAutoApprove, isSponsoredEnabled, regionFilters };
    }


    handlePartnerFilterChange = (event: any, index: number, value: Partner) => {
        this.setPartner(value);
    }

    handleRegionFilterChange = (event: any, index: number, value: Region) => {
        this.pushFilterUrl(this.state.partnerFilter, value);
        this.setPartnerAndRegion(this.state.partnerFilter, value);
    }

    handleTypeFilterChange = (event: any, index: number, value: TypeFilter) => {

        this.setState({
            ...this.state,
            typeFilter: value,
        }, () => this.fetchGlances(true));
    }

    handleExpiryFilterChange = (event: any, index: number, value: boolean) => {
        this.setState({
            ...this.state,
            expiryFilter: value,
        }, () => this.fetchGlances(true));
    }

    handleStateFilterChange = (event: any, index: number, value: StateFilter) => {
        this.updateActions(value);
        this.setState({
            ...this.state,
            stateFilter: value,
        }, () => this.fetchGlances(true));
    }



    updateActions = (stateFilter) => {

        let possibleActions: Action[];
        switch (stateFilter) {
            case StateFilter.PENDING:
            case StateFilter.APPROVED:
                possibleActions = [Action.REMOVE];
                break;
            case StateFilter.REJECTED:
            case StateFilter.REMOVED:
            default:
                possibleActions = null;
        }
        this.setState({
            ...this.state,
            possibleActions,
        });
    }

    onSelectGlance = (element: GlancePair, selected: boolean) => {
        const newMap = new Map<string, boolean>(this.state.selectedGlances);
        if (selected) {
            newMap.set(element.data.glanceId, true);
        } else {
            newMap.delete(element.data.glanceId);
        }

        this.setState({
            ...this.state,
            selectedGlances: newMap,
        });
    }

    handleAction = (action: Action) => {
        this.setState({
            ...this.state,
            actionClicked: action,
            openConfirmDialog: true,
        });
    }

    handleActionConfirm = (action: Action) => {
        const selectedIds: string[] = [];
        this.state.selectedGlances.forEach((value: boolean, glanceId: string) => {
            selectedIds.push(glanceId);
        });
        this.setState({
            ...this.state,
            snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...',
            openSnackbar: true,
        });
        switch (action) {
            case Action.REMOVE:
                RestService.removePartnerPublishedGlances(this.state.partnerFilter, this.state.regionFilter, selectedIds, (success) => {
                    this.handleActionComplete(action, success);
                });
                break;
            default:
                break;
        }
    }

    handleActionComplete = (action: Action, success: boolean) => {
        if (success) {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Glance ' + Action[action] + ' done. Updating view...',
                openConfirmDialog: false,
                selectedGlances: new Map<string, boolean>(),
            });
            this.fetchGlances(true);
        } else {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Unable to ' + Action[action] + ' glances. Contact Glance Support.',
                openConfirmDialog: false,
            });
        }
    }

    closeConfirmDialog = () => {
        this.setState({
            ...this.state,
            openConfirmDialog: false,
        });
    }

    closeSnackbar = () => {
        this.setState({
            ...this.state,
            openSnackbar: false,
        });
    }

    searchHandler = (event: any) => {

        if (timer) {
            clearTimeout(timer);
        }
        this.setState({
            ...this.state,
            searchTerm: event.target.value,
        });

        timer = setTimeout(() => {
               this.fetchGlances(true);
        }, 800);

    }
    searchButton = () => {
        this.fetchGlances(true);
    }

    onPageChange = (page) => {
        this.setState({
            ...this.state,
            selectedPage: page.selected + 1,
            selectedGlances: new Map<string, boolean>(),
        }, () => {
            this.fetchGlances(false);
        });
    }

    getGridItems = (glancePairs: GlancePair[]) => {
     // checking if the glance is created after march 1st 2023 if it's from spaces, non-space glances are not checked.

       const gridItems = glancePairs.map((pair: GlancePair) => {      
            if(pair.data.destinationIdentifier !== Identifier.SPACE || (pair.data.destinationIdentifier === Identifier.SPACE && pair.data.updatedAtInSecs >= 1677628800))
            return (<GridTile key={pair.data.glanceId} style={{flex:1}}
                containerElement={
                    <Glance glance={pair} selected={this.state.selectedGlances.get(pair.data.glanceId)}
                        partner={this.state.partnerFilter} region={this.state.regionFilter}
                        onSelect={(selected: boolean) => this.onSelectGlance(pair, selected)} />
                }>
            </GridTile>); }) 
        return gridItems.filter((el)=> el !== undefined);
    }

    render() {
        const actions = [];
        const { selectedPage, perPage, glancePairs, showLoader, totalGlances } = this.state;
        actions.push(
            <FlatButton label='Cancel' primary={true} style={{width: '100%'}}
                onClick={this.closeConfirmDialog} />,
        );
        actions.push(
            <FlatButton label={'Yes, ' + Action[this.state.actionClicked]} primary={true} style={{width: '100%'}}
                onClick={() => this.handleActionConfirm(this.state.actionClicked)} />,
        );
        return (
            <div>
                {
                    !this.state.partnerFilter ?
                        <Toolbar style={{ marginTop: '2%' }}>
                            <ToolbarGroup firstChild={true}>
                                <DropDownMenu value={this.state.partnerFilter}
                                    onChange={this.handlePartnerFilterChange}  >
                                    <MenuItem value={null} primaryText={'Click here select to Partner'} key={'empty'}></MenuItem>
                                    {
                                        this.props.studioAppConfig.partners.map((item, index) => {
                                            return (
                                                <MenuItem value={item} primaryText={item.name} key={item.partnerId} />
                                            );
                                        })
                                    }
                                </DropDownMenu>
                            </ToolbarGroup>
                        </Toolbar>
                        :
                        <Toolbar style={{ marginTop: '2%' }}>
                            <ToolbarGroup firstChild={true}>
                                <ToolbarTitle text='Filters' style={{ marginLeft: '24px' }} />
                                <ToolbarSeparator />
                                <DropDownMenu value={this.state.partnerFilter}
                                    onChange={this.handlePartnerFilterChange}  >
                                    <MenuItem value={null} primaryText={'Select Partner'} key={'empty'}></MenuItem>
                                    {
                                        this.props.studioAppConfig.partners.map((item, index) => {
                                            return (
                                                <MenuItem value={item} primaryText={item.name} key={item.partnerId} />
                                            );
                                        })
                                    }
                                </DropDownMenu>

                                <DropDownMenu value={this.state.regionFilter}
                                    onChange={this.handleRegionFilterChange}>
                                    <MenuItem value={null} primaryText={'Select Region'} key='empty'></MenuItem>
                                    {
                                        this.state.regionFilters.map((item, index) => {
                                            return (
                                                <MenuItem value={item} primaryText={Utils.getReadableRegionName(item)} key={index} />
                                            );
                                        })
                                    }
                                </DropDownMenu>
                                {
                                    this.state.partnerAutoApprove ?
                                        <DropDownMenu value={this.state.stateFilter}
                                            onChange={this.handleStateFilterChange}>
                                            <MenuItem value={StateFilter.APPROVED} primaryText='Approved Glances' />
                                            <MenuItem value={StateFilter.REMOVED} primaryText='Removed Glances' />
                                        </DropDownMenu> :
                                        <DropDownMenu value={this.state.stateFilter}
                                            onChange={this.handleStateFilterChange}>

                                            <MenuItem value={StateFilter.PENDING} primaryText='Pending Approval' />
                                            <MenuItem value={StateFilter.APPROVED} primaryText='Approved Glances' />
                                            <MenuItem value={StateFilter.REJECTED} primaryText='Rejected Glances' />
                                            <MenuItem value={StateFilter.REMOVED} primaryText='Removed Glances' />
                                        </DropDownMenu>
                                }
                                <DropDownMenu value={this.state.typeFilter}
                                    onChange={this.handleTypeFilterChange}>
                                    <MenuItem value={TypeFilter.ALL} primaryText='Everything' />
                                    <MenuItem value={TypeFilter.STORY} primaryText='Stories' />
                                    <MenuItem value={TypeFilter.WALLPAPER} primaryText='Wallpapers' />
                                    {this.state.isSponsoredEnabled ?
                                        <MenuItem value={TypeFilter.SPONSORED} primaryText='Sponsored' /> : ''}
                                </DropDownMenu>
                                <DropDownMenu value={this.state.expiryFilter}
                                    onChange={this.handleExpiryFilterChange}>
                                    <MenuItem value={false} primaryText='Active Glances' />
                                    <MenuItem value={true} primaryText='Expired Glances' />
                                </DropDownMenu>
                                <div className='wrap'>
                                    <div className='search'>
                                        <input type='text'
                                            value={this.state.searchTerm}
                                            onChange={this.searchHandler}
                                            placeholder='Search...'
                                            className='searchTerm'
                                        />
                                        <div>{totalGlances}</div>
                                        <button type='submit' className='searchButton' onClick={this.searchButton}>
                                            <i>
                                                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'>
                                                    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
                                                </svg>
                                            </i>
                                        </button>
                                    </div>
                                </div>
                            </ToolbarGroup>
                        </Toolbar>
                }
                {this.state.regionFilter ? (
                    <Loader show={showLoader} message={this.state.loadMessage}>
                    {
                        glancePairs && glancePairs.length > 0 ?
                        <div>
                            <GridList
                                style={{ width: '100%', margin: '0 auto', marginTop: '2%' }}
                                cols={4}
                                padding={15}
                                cellHeight='auto'>
                                {
                                    //calling a method to get filtered grid titles, as filtering here directly is causing blank gridList
                                    this.getGridItems(glancePairs)
                                }
                            </GridList>
                        </div>
                        : <EmptyMessage message='No glances for selected filters'></EmptyMessage>

                    }
                    </Loader>



                        ) : <EmptyMessage message={this.state.loadMessage}></EmptyMessage>
                }
    {totalGlances > perPage && <div id='react-paginate'>
  <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                pageRangeDisplayed={3}
                marginPagesDisplayed={3}
                breakLabel={<span className='gap'>...</span>}
                pageCount={Math.ceil(totalGlances/perPage)}
                onPageChange={this.onPageChange}
                forcePage= {selectedPage -1}
                activeClassName='active'
                />
                    </div>
                }

                {
                    this.state.possibleActions && this.state.selectedGlances && this.state.selectedGlances.size > 0 ?
                        <div style={styles.footer}>
                            <RaisedButton
                                icon={removeIcon}
                                label={'Remove Selected (' + this.state.selectedGlances.size + ')'}
                                primary
                                buttonStyle={this.state.possibleActions.indexOf(Action.REMOVE) < 0 ? styles.disabledButton : styles.deleteButton}
                                style={styles.footerButton}
                                onClick={() => this.handleAction(Action.REMOVE)}
                                disabled={this.state.possibleActions.indexOf(Action.REMOVE) < 0}
                            />
                        </div> : ''
                }
                <Dialog modal={false}
                    open={this.state.openConfirmDialog}
                    onRequestClose={this.closeConfirmDialog}

                    actions={actions}
                >
                    Please confirm that you want to {Action[this.state.actionClicked]} these glances.
                </Dialog>
                <Snackbar open={this.state.openSnackbar} message={this.state.snackbarMessage} onRequestClose={this.closeSnackbar} autoHideDuration={2000} />
            </div>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};

export default connect(mapStateToProps)(ModeratorGlances);



// WEBPACK FOOTER //
// ./src/components/ModeratorGlances.tsx